import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, Router, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

export interface ComponentCanDeactivate {
    canDeactivate: () => Observable<boolean>;
}
@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
    constructor(private router: Router) {}

    canDeactivate(
        component: any,
        _currentRoute: ActivatedRouteSnapshot,
        _currentState: RouterStateSnapshot,
        _nextState: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        const c = component.canDeactivate();
        return c;
    }
}
